import { render, staticRenderFns } from "./AmendmentTimeline.vue?vue&type=template&id=7b321020&scoped=true&"
import script from "./AmendmentTimeline.vue?vue&type=script&lang=ts&"
export * from "./AmendmentTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./AmendmentTimeline.vue?vue&type=style&index=0&id=7b321020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b321020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VContainer,VRow})
